import { apiSlice } from './apiSlice';
import { ENDPOINTS } from '../../constants/urls';

export const feedbackApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL FEEDBACKS
    getAllFeedbacks: builder.query({
      query: ({ category, status }) => ({
        url: `${ENDPOINTS.FEEDBACKS}/`,
        params: { category, status },
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: false },
      providesTags: ['Feedbacks'],
    }),

    // GET SINGLE FEEDBACK
    getSingleFeedback: builder.mutation({
      query: ({ feedbackId }) => ({
        url: `${ENDPOINTS.FEEDBACKS}/${feedbackId}/`,
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: false },
    }),

    // CREATE FEEDBACK
    createFeedback: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.FEEDBACKS}/create`,
        method: 'POST',
        body: data,
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Feedbacks'],
    }),

    // UPDATE FEEDBACK
    updateFeedback: builder.mutation({
      query: ({ feedbackId, data }) => ({
        url: `${ENDPOINTS.FEEDBACKS}/${feedbackId}/`,
        method: 'PUT',
        body: data,
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Feedbacks'],
    }),

    // DELETE FEEDBACK
    deleteFeedback: builder.mutation({
      query: ({ feedbackId }) => ({
        url: `${ENDPOINTS.FEEDBACKS}/${feedbackId}/`,
        method: 'DELETE',
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Feedbacks'],
    }),

    // LIKE / UNLIKE FEEDBACK
    toggleFeedbackVote: builder.mutation({
      query: ({ feedbackId }) => ({
        url: `${ENDPOINTS.FEEDBACKS}/${feedbackId}/vote`,
        method: 'POST',
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Feedbacks'],
    }),

    // GET FEEDBACK CATEGORIES WITH COUNTS
    getFeedbackCategories: builder.query({
      query: () => ({
        url: `${ENDPOINTS.FEEDBACKS}/categories/`,
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: false },
      providesTags: ['Feedbacks'],
    }),
  }),
});

export const {
  useGetAllFeedbacksQuery,
  useGetSingleFeedbackMutation,
  useCreateFeedbackMutation,
  useUpdateFeedbackMutation,
  useDeleteFeedbackMutation,
  useToggleFeedbackVoteMutation,
  useGetFeedbackCategoriesQuery,
} = feedbackApiSlice;